import Http from "./Http";

export class StatisticsService extends Http {
  /**
   * Get income statistics
   * @param {Object} params
   * @param {string} params.startDate
   * @param {string} params.endDate
   * @param {string} params.priceType 1 - usd, 2 - matic
   */
  getIncomeStats(params) {
    return this.get("/statistics/income", { params });
  }

  /**
   * Get transaction statistics
   * @param {Object} params
   * @param {string} params.startDate
   * @param {string} params.endDate
   */
  getTxStats(params) {
    return this.get("/statistics/transactions", { params });
  }

  /**
   * Get total tx count, usd/crypto income and recurrent payments percentage
   */
  getCounterStats() {
    return this.get("/statistics/counters");
  }

  /**
   * Get distributions statistics
   * @param {string} params.startDate
   * @param {string} params.endDate
   */
  getDistributions(params) {
    return this.get("/statistics/distributions", { params });
  }

  /**
   * Get sales statistics
   * @param {string} params.startDate
   * @param {string} params.endDate
   * @param {string} params.priceType 1 - usd, 2 - matic
   */
  getSalesStats(params) {
    return this.get("/statistics/sales", { params });
  }

  /**
   * Generate CSV file with income statistics
   * @param {string} params.startDate
   * @param {string} params.endDate
   */
  downloadCsv(params) {
    return this.post("/statistics/income/csv", undefined, {
      params,
      responseType: "text",
    });
  }
}

export default new StatisticsService();
